<template>
  <v-autocomplete
    hide-details="auto"
    :items="products"
    :loading="loadingProducts"
    v-model="filterDatas.product"
    item-text="name"
    item-value="id"
    label="Product"
    outlined
    dense
    @change="emitInput(filterDatas.product)"
    clearable
    :search-input.sync="searchProduct"
  ></v-autocomplete>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    products: [],
    selectedProduct: null,
    searchProduct: null,
    loadingProducts: false,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_PRODUCT_FILTER', data);
      this.$emit('input', this.filterDatas.product);
    },
    getProductsByQuery(query = '') {
      this.loadingProducts = true;
      this.$store
        .dispatch('product/GetProduct', {
          query: this.filterDatas.productquery
            ? this.filterDatas.productquery
            : query,
        })
        .then((res) => {
          this.products = res;
          this.loadingProducts = false;
        })
        .catch((err) => {
          this.loadingProducts = false;
          this.messages = err.data.title;
        });
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectedProduct = null;
      },
      deep: true,
    },
    searchProduct: {
      handler(val) {
        this.$store.commit('UPDATE_PRODUCT_QUERY_FILTER', val);
        this.getProductsByQuery(val);
      },
      deep: true,
    },
  },
  created() {
    this.$emit('input', this.filterDatas.product);

    this.getProductsByQuery();
  },
};
</script>
